import { Dialog } from "@headlessui/react";
import Button from "../../../components/button/Button";
import {Modal, ModalTitle} from "../../../components/modal/Modal";
import { ModalProp } from "../../../components/modal/Modal";
import { Messages } from "../../../model/Message";
import { convertDateTimeToString, convertDateToJapaneseString, convertDateToString } from "../../../utility/ConvertUtily";
import { ReplyButton } from "../../../model/ReplyButton";
import { Company } from "../../../model/Companies";
import Badge from "../../../components/badges/Badges";

type MessagePreviewModalProps = {
  data?: Messages;
  company: Company;
  replyButtonSelected?: ReplyButton;
  onClickSubmit: (data: Messages) => Promise<void>;
};

export const MessagePreviewModal = ({
  open,
  toggle,
  closeOnClickOutside,
  data,
  company,
  replyButtonSelected,
  onClickSubmit,
}: ModalProp & MessagePreviewModalProps) => {

  // Date型のアイテムのチェック
  const IsDate = (date: any): boolean => {
    const dateToDate = new Date(date);
    return (date !== undefined)
    ? Number.isNaN(dateToDate.getTime())
      ? false
      : true
    : false
  };

  const isRepryButton = replyButtonSelected !== undefined && replyButtonSelected.id !== 'undefined';
  let muinusHieht = 2;
  if(data?.eventFlg && data?.link !== 'none') {
    muinusHieht += 4;
  }
  if(isRepryButton) {
    muinusHieht += 4.5;
  }
  const bodyHeight = `calc(100vh - 20rem - ${muinusHieht}rem)`;

  const weekName = ['日','月','火','水','木','金','土'];
  const dayCount = {day: data?.sendDate.getDay() ?? 0, count: Math.floor(((data?.sendDate.getDate() ?? 0) - 1) / 7) + 1};

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all ">
          <div className="p-4 -mt-8 pb-0">
            <ModalTitle mainTitle="お知らせ配信前 確認" subTitle="内容をご確認ください。"/>
          </div>
          {data !== undefined ? (
            <div className={"h-[calc(100vh_-_16rem)] grid grid-cols-2 gap-4 p-4"}>
              {/* 外枠 スマホ画面サイズ 5.7inch 1080*2280 440dpi相当 */}
              <div className={"h-[calc(100vh_-_18rem)] w-[420px] border border-4 border-gray-500 rounded-2xl pt-3"}>
                {/* 本文表示エリア */}
                <div className={'overflow-auto p-2 text-2xl leading-none tracking-tight'} style={{height: bodyHeight}}>
                  {/* 配信日 */}
                  <div className={'text-gray-400'}>
                    配信 : {convertDateToJapaneseString(data.sendDate)}
                  </div>
                  {/* 配信者 */}
                  <div className='text-gray-400 pt-1'>
                    配信者 : {data.authorName}
                  </div>
                  {/* タイトル */}
                  <div className={"text-4xl font-bold py-2"}>
                    {data.title}
                  </div>
                  {/* イベント日時 */}
                  {data.eventFlg && (<>
                  <hr className={'border-black'}/>
                  <div className={"flex items-center space-x-2 py-2"}>
                    <div className={"whitespace-nowrap self-start leading-7 pt-1"}>日時</div>
                    <div className={"text-3xl w-full"}>
                      {convertDateToJapaneseString(data.eventAt)}
                      {!data.isEventTimeEmpty
                        ? (
                          <div className={"flex justify-end items-end space-x-1"}>
                            <div className={"text-2xl"}>開始</div>
                            <div>{`${String(data.eventAt.getHours()).padStart(2, "0")}:${String(data.eventAt.getMinutes()).padStart(2, "0")}`} ~</div>
                            <div className={"text-2xl"}>終了</div>
                            <div>{`${String(data.eventEndAt.getHours()).padStart(2, "0")}:${String(data.eventEndAt.getMinutes()).padStart(2, "0")}`}</div>
                          </div>
                        )
                        : (<></>)}
                    </div>
                  </div></>)}
                  {/* イベント会場 */}
                  {data.eventFlg && (
                  <div className={"flex items-start leading-6 space-x-2 py-2"}>
                    <div className={"whitespace-nowrap"}>開催会場</div>
                    <div className={"text-3xl leading-none"}>{data.eventVenue}</div>
                  </div>)}
                  <hr className={'border-black'}/>
                  {/* 配信先 */}
                  <div className='py-2'>
                    <div>配信先 : <span className='font-bold'>全体</span></div>
                  </div>
                  <hr className='border-black'/>
                  {/* 本文 */}
                  <div className={"p-2 whitespace-pre-line text-3xl"}>
                    {data.body}
                  </div>
                  {/* 画像 */}
                  {(data.image !== '' && data.image !== undefined) && (<div className={"py-1"}>
                    <img src={data.image} alt={''}/>
                  </div>)}
                  {/* URLリンクボタン */}
                  {data.urlButtonFlg && (
                    <div
                      className={"bg-[#FF4B00] rounded-[1.3rem] p-5 my-3 mx-auto h-fit flex w-[calc(100%_-_1.5rem)] items-center text-white font-bold drop-shadow-md"}>
                      <div className={"w-full text-xl leading-none text-center"}>{data.urlButtonName}</div>
                    </div>
                  )}
                  {/* 問い合わせ先 */}
                  {data.contactInformation && (<>
                  <hr className={'border-black'}/>
                  <div className={"flex items-start space-x-2 py-2"}>
                    <div className={"whitespace-nowrap"}>問い合わせ先</div>
                    <div className={"text-2xl leading-none"}>{data.contactInformation}</div>
                  </div></>)}
                </div>
                {/* ミーティング参加ボタン・返信ボタン表示エリア */}
                {(isRepryButton || (data.eventFlg && data.link !== 'none')) && (
                  <div className={`h-[calc(11rem_-_1px)] border-t border-black p-3 space-y-3 overflow-hidden`}>
                    {isRepryButton && (
                      <div className={"h-16 flex flex-cols space-x-2 items-center"}>
                        {replyButtonSelected?.buttonName.map((name, index) => {
                          let buttonBgColor: string | undefined = undefined;
                          switch(replyButtonSelected?.buttonColor.at(index)) {
                            case '0':
                              // 青
                              buttonBgColor = 'bg-[#005AFF]';
                              break;
                            case '1':
                              // 赤
                              buttonBgColor = 'bg-[#FF4B00]';
                              break;
                            case '2':
                              // 緑
                              buttonBgColor = 'bg-[#03AF7A]';
                              break;
                            default:
                              // グレー
                              buttonBgColor = 'bg-gray-300';
                              break;
                          }
                          return (<div
                            key={`${name}-${index}`}
                            className={`rounded-[1.3rem] px-2 py-3 h-full flex w-full items-center text-white font-bold drop-shadow-md ${buttonBgColor ?? 'bg-gray-300'}`}>
                            <div className={"w-full text-xl leading-none text-center"}>{name}</div>
                          </div>)
                        })}
                      </div>
                    )}
                    {(data.eventFlg && data.link !== 'none') && (
                      <div
                        className={'rounded-[1.3rem] py-3 px-2 h-fit w-full items-center text-white font-bold drop-shadow-md bg-[#03AF7A]'}>
                        <div className={"w-full text-2xl leading-none text-center"}>オンラインで参加する</div>
                        <div className={"w-full text-xl leading-none text-center"}>開始5分前から参加できます</div>
                      </div>)
                    }
                  </div>
                )}
              </div>
              <div className={"grid grid-cols-3 gap-y-4 gap-x-1 w-[420px] h-fit max-h-full overflow-auto"}>
                <div>配信先</div>
                <div className={"col-span-2 flex flex-wrap"}>
                  <Badge className={"sm:text-xl sm:font-bold"} color={"yellow"}>団体全体</Badge>
                </div>
                <div>配信者</div>
                <div className={"col-span-2 text-xl font-bold"}>{data.authorName}</div>
                <div>配信日</div>
                <div className={"col-span-2 text-xl font-bold"}>{convertDateTimeToString(data.sendDate)}</div>
                <div>掲載終了日</div>
                <div className={"col-span-2 text-xl font-bold"}>{IsDate(data.publishEndAt) ? convertDateToString(data.publishEndAt!) : ''}</div>
                {/* <div>繰り返し配信</div>
                <div className={"col-span-2 grid grid-cols-4"}>
                  {data.regularFlg && (
                    <>
                      <div>間隔</div>
                      <div className={"col-span-3"}>
                        {data.regularSetting?.repeatIntervalNum}
                        {data.regularSetting?.repeatIntervalType === 'weekly' ? '週間ごと': 'ヶ月ごと'}
                      </div>
                      <div></div>
                      <div className={"col-span-3"}>
                        {data.regularSetting?.repeatIntervalType === 'weekly' && data.regularSetting?.dayOfWeek?.map((week, index) => {
                          return week
                            && weekName.at(index);
                        }).filter((week) => week).join('・')}
                        {data.regularSetting?.repeatIntervalType === 'monthly' && (<>
                          {data.regularSetting?.everyMonthType === 'day' && `毎月${data?.sendDate!.getDate()}日`}
                          {data.regularSetting?.everyMonthType === 'week' && `毎月第${dayCount.count} ${weekName.at(dayCount.day)}曜日`}
                        </>)}
                      </div>
                      {data.eventFlg && (<div className={"col-span-4 text-right pr-4"}>{`イベントの${data.regularSetting?.previousDeliveryDate}日前に配信`}</div>)}
                      <div>終了日</div>
                      <div className={"col-span-3"}>
                        {data.regularSetting?.endDateType === 'none' && 'なし'}
                        {data.regularSetting?.endDateType === 'endDate' &&
                          IsDate(data.regularSetting?.endDate) ? convertDateTimeToString(new Date(data.regularSetting?.endDate!)): ''}
                        {data.regularSetting?.endDateType === 'numberOfRepeats' && `${data.regularSetting?.numberOfRepeats}回配信`}
                      </div>
                    </>
                  )}
                </div> */}
                <div>返信ボタン</div>
                <div className={"col-span-2 text-xl font-bold"}>{replyButtonSelected?.name}</div>
                {data.eventFlg && (<>
                  <div>イベントタイプ</div>
                  <div className={"col-span-2 text-xl font-bold"}>{data.eventType}</div>
                  <div>ミーティングURL</div>
                  <div className={"col-span-2 text-xl font-bold text-ellipsis whitespace-nowrap overflow-hidden"}>
                    {data.link === 'none'
                      ? '設定なし'
                      : data.link === ''
                       ? `直接入力: ${data.url}`
                       :(<span title={data.link}>{data.link}</span>)
                    }
                  </div>
                </>)}
                {data.urlButtonFlg && (<>
                  <div>URLリンク</div>
                  <div className={"col-span-2 text-xl font-bold"}>{data.urlLink}</div>
                </>)}
              </div>
            </div>
          ) : ''}
          <div className="p-4 bg-gray-100">
            <div className="flex justify-end">
              <Button
                className="mx-2 mt-1 text-indigo-500"
                outline
                onClick={toggle}
                children={'戻る'}
              />
              <Button
                className="mt-1"
                children={'配信'}
                onClick={onClickSubmit}
              />
            </div>
          </div>
        </Dialog.Panel>
    </Modal>
  );
};
